import React from 'react';

import { teamColumns } from '@utils/columns';

import withPagination from '@shared/withFilteredPagination';
import FilterTable from '@shared/FilterTable';

const TeamsIndex = (props) => {
  const primaryAction = props.newUrl ? { content: I18n.t("actions.create_x", { x: I18n.t("activerecord.models.team.one") }), url: props.newUrl } : null
  return(
    <FilterTable
      pageProps={{
        title: I18n.t("activerecord.models.team.other"),
        primaryAction: primaryAction
      }}
      columnsInfo={ teamColumns }
      tabs={ props.tabs }
      {...props}
    />
  )
}

export default withPagination(TeamsIndex, {
  // The disabled teams are a tab of their own, so the list anyone works from is
  // not padded with teams that no longer dispatch anything.
  mapPropsToInitialFilters: (props) => ({
    tabs: props.statusTabs,
    statusTabIndex: 0,
    status: "active",
  }),
  mapPropsToInitialRecords: (props) => props.records,
  mapPropsToPagy: (props) => props.pagy,
  paramsName: "filters",
  filterURL: "/teams/filter",
})
